import { msg } from '@lingui/macro';

export const SuppliersRoutes = {
  path: 'suppliers',
  async lazy() {
    const { Parent } = await import('pages/my-subsuppliers');
    return { Component: Parent };
  },
  handle: {
    name: 'My subsuppliers',
    category: 'My subsuppliers list view',
    title: msg`My subsuppliers`,
    supplierTitle: msg`Subsupplier management`,
  },
  children: [
    {
      index: true,
      async lazy() {
        const { Index } = await import('pages/my-subsuppliers');
        return { Component: Index };
      },
    },
    {
      path: ':supplierId/:supplierOrgId',
      async lazy() {
        const { Details } = await import('pages/my-subsuppliers');
        return { Component: Details };
      },
      handle: { name: 'Supplier Detail Page', category: 'My subsuppliers' },
      children: [
        {
          index: true,
          async lazy() {
            const { BasicInfo } = await import('pages/my-subsuppliers');
            return { Component: BasicInfo };
          },
        },
        {
          path: 'edit',
          async lazy() {
            const { EditSupplier } = await import('pages/my-subsuppliers');
            return { Component: EditSupplier };
          },
          handle: { name: 'Edit supplier', category: 'My subsuppliers' },
        },
        {
          path: 'facilities',
          async lazy() {
            const { Facilities } = await import('pages/my-subsuppliers');
            return { Component: Facilities };
          },
          handle: { name: 'Facilities', category: 'My subsuppliers' },
          children: [
            {
              path: 'add',
              async lazy() {
                const { SupplierFacilitiesModal } = await import('pages/my-subsuppliers');
                return { Component: SupplierFacilitiesModal };
              },
            },
            {
              path: ':facilityId/edit',
              async lazy() {
                const { SupplierFacilitiesEditModal } = await import('pages/my-subsuppliers');
                return { Component: SupplierFacilitiesEditModal };
              },
            },
            {
              path: ':facilityId/details',
              async lazy() {
                const { SupplierFacilityDetails } = await import('pages/my-subsuppliers');
                return { Component: SupplierFacilityDetails };
              },
            },
          ],
        },
      ],
    },
    {
      path: 'add',
      async lazy() {
        const { AddSupplier } = await import('pages/my-subsuppliers');
        return { Component: AddSupplier };
      },
      handle: { name: 'Add new supplier', category: 'My subsuppliers' },
    },
  ],
};
